<template>
  <AdminForm
    :config="config"
    :form="form"
    :isBusy="isBusy"
    :options="options"
    @submit:create:success="submitCreateSuccess"
  ></AdminForm>
</template>

<script>
import AdminForm from "@/components/Global/AdminForm";
import config from "./config";

export default {
  name: "ReferenceForm",
  components: {
    AdminForm,
  },
  props: ["id_to_edit"],
  data() {
    return {
      config: config,
      form: {
        product_id: null,
        current_warehouse_id: null,
        supplier_id: null,
        status_slug: null,
      },
      isBusy: false,
    };
  },
  computed: {
    options: function () {
      return {
        product_id_options: this.$store.getters["product/getAll"].selectOptions("id", "name"),
        current_warehouse_id_options: this.$store.getters["warehouse/getAll"].map((warehouse) => ({
          value: warehouse.id,
          text: warehouse.internal_code + " - " + warehouse.name,
        })),
        supplier_id_options: this.$store.getters["company/getByTypeCode"]("FRNI").selectOptions(
          "id",
          "name"
        ),
        status_slug_options: this.$store.getters["status/getByGroup"]("reference")
          .filter(
            (status) =>
              (this.form.status_slug != "reference-en-stock" ||
              status.status_slug != "reference-en-location")
          )
          .selectOptions("status_slug", "name"),
      };
    },
  },
  mounted() {
    // Duplication
    // Chargement de la copie qui a été préparée s'il y en a une
    const copy = this.$store.getters[config.storeNamespace + "/getCopy"];
    if (!this.id_to_edit && copy) {
      this.form = { ...copy };
      this.$store.commit("reference/emptyCopy");
    }

    // Edition
    const id =
      this.$route.name == config.editRouteName && this.$route.params.id
        ? this.$route.params.id
        : this.id_to_edit || null;

    if (id) {
      this.isBusy = true;
      this.$store
        .dispatch(config.storeNamespace + "/getItem", {
          id: id,
          wait: true,
        })
        .then(() => {
          let item = _.cloneDeep(this.$store.getters[config.storeNamespace + "/getItem"](id));
          this.form = {
            ...item,
            product_id: item.product ? item.product.id : null,
            supplier_id: item.supplier ? item.supplier.id : null,
            status_slug: item.status ? item.status.status_slug : null,
            purchase_date: item.purchase_date
              ? this.$moment(item.purchase_date).format("YYYY-MM-DD")
              : null,
          };
          this.isBusy = false;
        });
    }

    this.$store.dispatch("product/getAllForSelect");
    // Création : l'utilisateur rattaché à un seul entrepôt y crée ses références.
    const userWarehouse = this.$store.getters["auth/warehouse"];
    if (!id && !this.form.current_warehouse_id && userWarehouse) {
      this.form.current_warehouse_id = userWarehouse.id;
    }

    this.$store.dispatch("warehouse/getAll");
    this.$store.dispatch("company/getAllForSelect");
  },
  methods: {
    submitCreateSuccess(response) {
      this.$emit("submit:create:success", response);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Reference/ReferenceForm.vue